import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth-context";
import { ContentProvider } from "@/lib/content-context";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Partner from "@/pages/Partner";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import OurCafes from "@/pages/OurCafes";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Career from "@/pages/Career";
import SiteLayout from "@/components/SiteLayout";

import AdminLogin from "@/pages/admin/Login";
import AdminForgotPassword from "@/pages/admin/ForgotPassword";
import AdminResetPassword from "@/pages/admin/ResetPassword";
import AdminLayout from "@/pages/admin/Layout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminHomeEditor from "@/pages/admin/HomeEditor";
import AdminPagesEditor from "@/pages/admin/PagesEditor";
import AdminBlogEditor from "@/pages/admin/BlogEditor";
import AdminTheme from "@/pages/admin/ThemeEditor";
import AdminMedia from "@/pages/admin/MediaLibrary";
import AdminMessages from "@/pages/admin/Messages";
import AdminAccount from "@/pages/admin/Account";

function Protected({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-cream-light">
                <div className="font-headings tracked text-coffee">Loading…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
}

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <ContentProvider>
                    <Toaster
                        position="bottom-right"
                        toastOptions={{
                            style: {
                                background: "#1a0f00",
                                color: "#f5e6c8",
                                border: "1px solid #c5a059",
                                fontFamily: "DM Sans",
                            },
                        }}
                    />
                    <Routes>
                        {/* Public site */}
                        <Route element={<SiteLayout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/our-cafes" element={<OurCafes />} />
                            <Route path="/partner" element={<Partner />} />
                            <Route path="/blog" element={<Blog />} />
                            <Route path="/blog/:slug" element={<BlogDetail />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/privacy" element={<Privacy />} />
                            <Route path="/terms" element={<Terms />} />
                            <Route path="/careers" element={<Career />} />
                        </Route>

                        {/* Admin */}
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
                        <Route path="/admin/reset-password" element={<AdminResetPassword />} />
                        <Route
                            path="/admin"
                            element={
                                <Protected>
                                    <AdminLayout />
                                </Protected>
                            }
                        >
                            <Route index element={<AdminDashboard />} />
                            <Route path="home" element={<AdminHomeEditor />} />
                            <Route path="pages" element={<AdminPagesEditor />} />
                            <Route path="blog" element={<AdminBlogEditor />} />
                            <Route path="theme" element={<AdminTheme />} />
                            <Route path="media" element={<AdminMedia />} />
                            <Route path="messages" element={<AdminMessages />} />
                            <Route path="account" element={<AdminAccount />} />
                        </Route>

                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </ContentProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}
